export default function filterEffects(effects, type) {
  return effects?.filter((eff) => eff.effect === type)
}
